// File: src/services/announcementService.js
// Client wrapper for the header announcements API. Mirrors the platform's
// service pattern (Bearer token from localStorage, JSON, handleResponse).

const API_URL = '/api/announcements';

const getHeaders = () => ({
  'Authorization': `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

const handleResponse = async (response) => {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw data || { message: `Request failed with status ${response.status}` };
  }
  return data;
};

const request = async (method, path, body) =>
  handleResponse(await fetch(`${API_URL}${path}`, {
    method,
    headers: getHeaders(),
    body: body === undefined ? undefined : JSON.stringify(body),
  }));

// Everyone
export const getFeed = () => request('GET', '/feed');
export const markViewed = (id) => request('POST', `/${id}/view`);

// Admins
export const listAllAnnouncements = () => request('GET', '/admin/announcements');
export const createAnnouncement = (payload) => request('POST', '/admin/announcements', payload);
export const updateAnnouncement = (id, payload) => request('PUT', `/admin/announcements/${id}`, payload);
export const archiveAnnouncement = (id) => request('POST', `/admin/announcements/${id}/archive`);
export const unarchiveAnnouncement = (id) => request('POST', `/admin/announcements/${id}/unarchive`);
export const deleteAnnouncement = (id) => request('DELETE', `/admin/announcements/${id}`);

export const listAdmins = () => request('GET', '/admin/admins');
export const searchUsers = (q) => request('GET', `/admin/user-search?q=${encodeURIComponent(q)}`);
export const addAdmin = (userId) => request('POST', '/admin/admins', { user_id: userId });
export const removeAdmin = (userId) => request('DELETE', `/admin/admins/${userId}`);
